/**
 * This browser's layout preferences: whether the sidebar is collapsed to
 * icons, and the colour theme. Persisted (see `persistConfig.ts`), so a
 * reload keeps them.
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type ThemeChoice = 'light' | 'dark' | 'system';

const slice = createSlice({
	name: 'ui',
	initialState: {
		/** The sidebar shows icons only (wide screens; small screens slide it in). */
		railCollapsed: false,
		theme: 'system' as ThemeChoice,
	},
	reducers: {
		toggleRail(state) {
			state.railCollapsed = !state.railCollapsed;
		},
		setTheme(state, action: PayloadAction<ThemeChoice>) {
			state.theme = action.payload;
		},
	},
});

export const { toggleRail, setTheme } = slice.actions;
export default slice.reducer;
